
import { mdiArrowLeft } from '@mdi/js'
export default {
  props: {
    isImageSizeComparisonDialogVisible: Boolean,
  },
  data(){
    return{
        mdiArrowLeft,
        sizeGuideDesktop: require('@/assets/sizeguide/sizeguide-desktop.png'),
        sizeGuideMobile: require('@/assets/sizeguide/sizeguide-mobile.png'),
    }
  },
  methods:{
    closeDialog(){
        this.$emit('closeImageSizeComparisonDialog')
    }
  }
}
